










































































import {
    Component, Inject, Mixins, Model, Watch,
} from 'vue-property-decorator';
import { AuthErrorCode } from '@luxtag/papybase';
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import RecTextField from '@/components/global/input/RecTextField.vue';
import SettingTextField from '@/components/settings/SettingTextField.vue';
import { user } from '@/plugins/papybase/papybaseInit';

@Component({
    components: {
        SettingTextField,
        RecTextField,
    },
    $_veeValidate: { validator: 'new' },
})
export default class Security extends Mixins(GAErrorEvent) {
    public changePasswordLoading = false;

    public showOldPassword = false;
    public showNewPassword = false;
    public showNewPasswordConfirmation = false;

    public form = {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
    }

    public dictionary = {
        attributes: {
            old_password: 'old password',
            new_password: 'new password',
            new_password_confirmation: 'new password confirmation',
        },
    }

    public mounted() {
        this.$validator.localize('en', this.dictionary);
    }

    public changePasswordEvent(action: string, label: any) {
        this.$ga.event('Change password', 'click', action, label);
    }

    public async changePassword() {
        // prevent for sign in to work while progress is show up
        if (this.changePasswordLoading) return;

        this.changePasswordEvent('Change password', 'Change password');
        const valid = await this.$validator.validateAll();
        if (valid) {
            this.changePasswordLoading = true;
            this.execChangePassword();
        }
    }

    public async execChangePassword() {
        try {
            await user.changePassword(this.jwt, this.form.oldPassword, this.form.newPassword);
            // Update successful.
        } catch (error) {
            this.errorEvent('changePassword', error);
            console.error(error);
            this.addAuthError(error);
        // An error happened.
        } finally {
            this.changePasswordLoading = false;
        }
    }

    public addAuthError(error:Error) {
        let fieldName = '';

        fieldName = 'old_password';

        const field = this.$validator.fields.find({ name: fieldName });
        if (!field) return;

        this.errors.add({
            id: field.id,
            field: field.name,
            msg: error.message,
        });
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        // called before the route that renders this component is confirmed.
        next((vm: any) => {
            // access to component instance via `vm`
            if (vm.$store.getters.getAuth.isLoginByEmail) {
                next();
            } else {
                next('/');
            }
        });
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }
}
